/* eslint-disable no-console */
import { RESPONSE } from '@factories/vasApiResponseConstants'
import { getConfig } from '@configs/evnConfig'
import { headerConstants } from '@components/MainWidget/common/headerConstants'
import { createVehicleData } from '@factories/createVehicleDataFactory'
import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { HeaderContentType } from '@enums/HeaderContentType'
import { VehicleData } from '../app/api/app/vehicleInfo/interface'

export async function fetchVehicleData(regNo: string): Promise<VehicleData | { error: string }> {
  const envConfig = process.env.ACKO_ENV

  try {
    const autoExternalApi = getConfig(envConfig)?.autoExternal
    if (!regNo) {
      return { error: RESPONSE.NUMBER_REQUIRED }
    }

    const response = await fetch(`${autoExternalApi}/${regNo}`, {
      headers: { [headerConstants.AUTO_HEADER_KEY]: headerConstants.AUTO_HEADER_VALUE },
    })

    if (!response.ok) {
      return { error: RESPONSE.FAILED_VEHICLE_DATA }
    }

    const data = await response.json()

    const responseData: VehicleData = createVehicleData(data)

    return responseData
  } catch (error) {
    console.error(RESPONSE.ERROR_AUTO_API, error)
    return { error: RESPONSE.ERROR_AUTO_API }
  }
}

export async function fetchVariantDetails(variantId: string): Promise<any> {
  try {
    if (!variantId) {
      throw new Error(RESPONSE.VARIANT_ID_ERROR)
    }

    const envConfig = process.env.ACKO_ENV
    const vehicleInfoService = getConfig(envConfig)?.vehicleInfoService

    const apiUrl = `${vehicleInfoService}/api/v1/vehicle-info/?variant_id=${variantId}`

    const variantResponse = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': HeaderContentType.JSON,
      },
    })

    if (!variantResponse.ok) {
      const errorBody = await variantResponse.text()
      throw new Error(`${RESPONSE.VARIANT_DETAIL_FAIL}: ${errorBody}`)
    }

    const variantData = await variantResponse.json()
    return variantData
  } catch (error: any) {
    console.error(RESPONSE.GET_VARIANT_DETAIL_ERROR, error)
  }
}

export const vehicleInfoService = async (regNo): Promise<any> => {
  try {
    const response = await fetch(API_URL_FACTORY.VEHICLE_INFO_API(regNo))

    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (err) {
    console.error(err, RESPONSE.ERROR_PUC_API)
    return null
  }
}
